export const departmentOptions = [
  { id: 1, name: "Account" },
  { id: 2, name: "Admin" },
  { id: 3, name: "DGT" },
  { id: 4, name: "Geotech" },
  { id: 5, name: "HR" },
  { id: 6, name: "Lab" },
  { id: 7, name: "Management" },
  { id: 8, name: "NDT" },
  { id: 9, name: "Procurement" },
  { id: 10, name: "Store" },
  { id: 11, name: "Marketing" },
  { id: 12, name: "Safety" },
  { id: 13, name: "Quality" },
  { id: 14, name: "Geophysical & Special Field Tes" },
];

export const branchOptions = [
  { id: 1, name: "Office" },
  { id: 2, name: "Site" },
];

export const designationOptions = [
  { id: 1, name: "Managing Director & Founder" },
  { id: 2, name: "Director & Founder" },
  { id: 3, name: "Office Assistant" },
  { id: 4, name: "Driver" },
  { id: 5, name: "Senior Supervisor" },
  { id: 6, name: "Manager- DGT" },
  { id: 7, name: "Senior Engineer" },
  { id: 8, name: "Senior Lab Assistant" },
  { id: 9, name: "Asst Account Manager" },
  { id: 10, name: "Lab Assistant" },
  { id: 11, name: "Senior Accountant" },
  { id: 12, name: "Store Incharge" },
  { id: 13, name: "Senior Geologist" },
  { id: 14, name: "CEO" },
  { id: 15, name: "Manager-Laboratory" },
  { id: 16, name: "Head -HR" },
  { id: 17, name: "Engineer" },
  { id: 18, name: "Manager- Geotech" },
  { id: 19, name: "Supervisor" },
  { id: 20, name: "Senior Geotechnical Engineer" },
  { id: 21, name: "Accountant" },
  { id: 22, name: "Business Development Executive" },
  { id: 23, name: "Senior Manager - Procurment" },
  { id: 24, name: "Digital Marketing Executive" },
  { id: 25, name: "Geologist" },
  { id: 26, name: "Junior Engineer" },
  { id: 27, name: "Geotechnical Engineer" },
  { id: 28, name: "Mechanic" },
  { id: 29, name: "Store Manager" },
  { id: 30, name: "Assistant Mechanic" },
  { id: 31, name: "Receptionist" },
  { id: 32, name: "Junior Geologist" },
  { id: 33, name: "Chief Technology Officer" },
  { id: 34, name: "Data Entry Operator" },
  { id: 35, name: "Assistant Manager -Site Execution" },
  { id: 36, name: "Quality Manager" },
  { id: 37, name: "Store Assistant" },
  { id: 38, name: "Chemical Analyst" },
  { id: 39, name: "Safety Engineer" },
  { id: 40, name: "Geophysicist" },
  { id: 41, name: "Report Assistant" },
  { id: 42, name: "Public Relation Officer" },
  { id: 43, name: "Head - Digital Marketing" },
  { id: 44, name: "Dy.Quality Manager" },
  { id: 45, name: "Product Manager" },
  { id: 46, name: "Marketing Executive" },
  { id: 47, name: "HR Executive" },
  { id: 48, name: "Manager- Geophysical & Special Field Test" },
  { id: 49, name: "Deputy Manager - Geotech" },
  { id: 50, name: "Manager- NDT & Instrumentation" },
  { id: 51, name: "Asst. Manager- Geotech execution" },
  { id: 52, name: "Technical Manager" },
  { id: 53, name: "Managing Director" },
  { id: 54, name: "General Manager" },
  { id: 55, name: "Senior Chemist" },
  { id: 56, name: "Deputy Technical Manager" },
  { id: 57, name: "Chemist" },
  { id: 58, name: "Technical Manager- Operations" },
  { id: 59, name: "Deputy Technical Manager - Operations" },
  { id: 60, name: "Senior Inspector" },
  { id: 61, name: "Inspector" },
  { id: 62, name: "Field Chemist" },
];

export const nablDesignationOptions = [
  { id: 1, name: "Technical Manager" },
  { id: 2, name: "Dy. Technical Manager" },
  { id: 3, name: "Test Engineer" },
  { id: 4, name: "Senior Test Engineer" },
  { id: 5, name: "Junior Test Engineer" },
  { id: 6, name: "Report Engineer" },
  { id: 7, name: "Senior Report Engineer" },
  { id: 8, name: "Junior Report Engineer" },
  { id: 9, name: "Geologist" },
  { id: 10, name: "Senior Geologist" },
  { id: 11, name: "Junior Geologist" },
  { id: 12, name: "Lab Assistant" },
  { id: 13, name: "Lab Helper" },
  { id: 14, name: "Lab Technician" },
  { id: 15, name: "Report Assistant" },
  { id: 16, name: "Managing Director" },
  { id: 17, name: "General Manager" },
  { id: 18, name: "Quality Manager" },
  { id: 19, name: "Senior Chemist" },
  { id: 20, name: "Chemist" },
  { id: 21, name: "Receptionist" },
  { id: 22, name: "Technical Manager- Operations" },
  { id: 23, name: "Deputy Technical Manager - Operations" },
  { id: 24, name: "Senior Inspector" },
  { id: 25, name: "Inspector" },
  { id: 26, name: "Field Chemist" },
  { id: 27, name: "Supervisor" },
];

export const HR_employeeStatus = [
  { id: 1, name: "Active" },
  { id: 2, name: "Terminated " },
  { id: 3, name: "Resigned" },
];
